'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Scenario'];
module.exports = angular.module('AVRO.Common.SaveNotification', dependencies).controller('SaveNotificationModalController', require('./controllers/SaveNotificationModalController')).directive('rmSaveNotificationModal', require('./directives/SaveNotificationModalDirective'));